// Core
import { connect } from 'react-redux';
// Actions
import { setSelection, setInner } from '../../../../ducks/noShop/Methods';

import Component from './Component';

const mapStateToProps = state => ({
    selection: state.noShop.q13.selection,
    inner: state.noShop.q13.inner,
});

const mapDispatchToProps = {
    setSelection,
    setInner,
};

const Q13 = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Q13;